import { GRID_BREAKPOINTS } from '../constants';
import { useWindowSize } from 'hooks/useWindowSize';
import { useCallback } from 'react';
import { futuraChainId, futuraContractAddress } from 'utils/config';
import FuturaOwnershipInfo from './FuturaOwnershipInfo';
import { Box, Button, Flex } from './ui';
import openSeaIcon from 'img/opensea.svg';
import { OwnedNft } from 'utils/types';
import { getOpenSeaUrl } from 'utils/networks';

interface FuturaItemHeaderProps {
  item: OwnedNft;
  tokenId: string;
}

/**
 * Represents the header that is used on the upper section of the Futura Token page.
 */
const FuturaItemHeader = ({ item, tokenId }: FuturaItemHeaderProps) => {
  const ws = useWindowSize();

  const navigateToOpenSea = useCallback(() => {
    if (item && tokenId) {
      window.open(
        getOpenSeaUrl(futuraChainId, futuraContractAddress, tokenId),
        '_blank'
      );
    }
  }, [item, tokenId]);

  return (
    <Flex
      width="100%"
      alignStart
      justifyBetween
      flexDirection={ws.width < GRID_BREAKPOINTS.md ? 'column' : 'row'}
    >
      <Flex flexDirection="column" marginBottom={2}>
        <Box fontWeight="bold" fontSize="20px" marginBottom={2}>
          {item?.metadata?.name}
        </Box>
        <FuturaOwnershipInfo nft={item} />
      </Flex>

      <Box
        width={ws.width < GRID_BREAKPOINTS.md ? '100%' : '215px'}
        paddingBottom={ws.width < GRID_BREAKPOINTS.md ? 2 : 0}
        marginTop={ws.width < GRID_BREAKPOINTS.md ? 3 : 0}
      >
        <Button
          padding="25px"
          height="40px"
          width="100%"
          backgroundColor="black"
          boxShadow="1"
          color="white"
          onClick={navigateToOpenSea}
        >
          <Flex width="100%" alignCenter justifyCenter>
            <img src={openSeaIcon} alt="View on Opensea" width="50px" />

            {(ws.width > GRID_BREAKPOINTS.xl || ws.width < GRID_BREAKPOINTS.md) && (
              <Box>View on OpenSea</Box>
            )}
          </Flex>
        </Button>
      </Box>
    </Flex>
  );
};

export default FuturaItemHeader;
